import { Routes } from '@angular/router';

import { CampaignDetailsComponent } from './campaign-details/campaign-details.component';
import { PromotionWinnersComponent } from './promotion-winners/promotion-winners.component';
import { PromotionDetailsComponent } from './promotion-details/promotion-details.component';
import { PromotionsComponent } from './promotions.component';
import { PromotionsListComponent } from './promotions-list/promotions-list.component';
import { PromotionsMissionsComponent } from './promotions-missions/promotions-missions.component';

export const routes: Routes = [
  {
    path: 'winners',
    component: PromotionWinnersComponent,
    data: { breadcrumb: 'promotions.promotionWinners', title: 'promotions.title' }
  },
  {
    path: '',
    component: PromotionsComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: PromotionsListComponent,
        data: { breadcrumb: 'leftSidebar.promotions', title: 'promotions.title' }
      },
      {
        path: 'missions',
        component: PromotionsMissionsComponent,
        data: { breadcrumb: 'promotions.tabs.missions', title: 'promotions.title' }
      }
    ]
  },
  {
    path: 'campaign/:campaignId',
    component: CampaignDetailsComponent,
    data: { breadcrumb: 'promotions.campaignDetails.title', title: 'promotions.title' }
  },
  {
    path: ':promotionId',
    component: PromotionDetailsComponent,
    data: { breadcrumb: 'promotions.promotionName', title: 'promotions.title' }
  }
];
